<template>
  <div>
    <b-form-group
      :label="label"
      :style="!label ? 'margin-bottom:0' : ''"
    >
      <validation-provider
        #default="{ errors }"
        :rules="{required: require_}"
        name="Departamento na G-Click"
      >
        <v-select
          ref="gClickdepartamentoSelect"
          v-model="value_"
          :options="departamentos"
          label="nome"
          :class="{'is-select-invalid': invalido}"
          :clearable="!require"
          :multiple="multiple"
          :disabled="disabled"
          @close="onTouch"
          @open="carregarDepartamentos"
          @search-change="carregarDepartamentosFiltrados"
          @input="enviarParaPai"
        />
        <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>

<style lang="scss">
.is-select-invalid  .vs__dropdown-toggle {
  border-color: #ea5455 !important;
  background-repeat: no-repeat !important;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) !important;
}
</style>

<script>
import { required } from '@validations'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import api from './api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'GClickDepartamentoSelect',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Departamento na G-Click',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    depsExternos: {
      type: [Object, Array],
      default: () => [],
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      required,
      valueAttr: null,
      foiAcessado: false,
      departamentos: [],
      departamentoPrimeiroAcesso: true,
      nomeDepartamento: { 0: { value: '' } },
      depsCarregados: [],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    async carregarDepartamentos() {
      if (this.departamentoPrimeiroAcesso) {
        const pageSize = 50
        try {
          const first = await api.getDepartamentos(0, pageSize)
          let content = first && first.data && Array.isArray(first.data.content) ? [...first.data.content] : []
          const totalPages = first && first.data && typeof first.data.totalPages === 'number' ? first.data.totalPages : 1

          if (totalPages > 1) {
            const requests = []
            for (let p = 1; p < totalPages; p += 1) {
              requests.push(api.getDepartamentos(p, pageSize))
            }
            const responses = await Promise.all(requests)
            responses.forEach(r => {
              if (r && r.data && Array.isArray(r.data.content)) {
                content = content.concat(r.data.content)
              }
            })
          }

          this.depsCarregados = [...content]
          this.setItensCarregados(content)
          this.departamentoPrimeiroAcesso = false
        } catch (err) {
          this.$errorFormated(err.response)
          throw err
        }
      } else {
        this.departamentos = [...this.depsCarregados]
        this.setItensCarregados(this.departamentos)
      }
    },
    carregarDepartamentosFiltrados(nomeDepartamento) {
      this.nomeDepartamento[0].value = nomeDepartamento

      api.getDepartamentosFiltrados(this.nomeDepartamento)
        .then(payload => {
          this.setItensCarregados(payload.data)
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.departamentoSelect.focus()
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.value_ = []
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.departamentos = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return 'O campo departamento na G-Click  é obrigatório'
      }
      return erro
    },
  },
}
</script>
